export function getConnectionFields(templates, items, authTemplate) {
  if (!authTemplate) {
    return items;
  }
  const template = templates?.find((t) => t.id === authTemplate.id);
  return template
    ? items.filter((item) => template.auth_parameters.includes(item.param_id))
    : items;
}
